import { BaseModal } from './base-modal'
import styles from './styles/modal-center.module.scss'
import { ModalWindowProps } from './types/modal.types'

export const ModalCenter = (props: ModalWindowProps) => {
  return (
    <BaseModal
      className={styles.modalWindowCenter}
      {...props}
    >
      {props.children}
    </BaseModal>
  )
}
